export const cars = [
    {
        url: 'https://images.unsplash.com/photo-1642201855395-1c8b44e6e42b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1780&q=80',
        id: 1

    },

    {
        url: 'https://images.unsplash.com/photo-1628273148878-b9ebaec15818?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
        id: 2
    },
    {
        url: 'https://images.unsplash.com/photo-1563299065-6eb5245c32f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8ZmVyYXJyaXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60',
        id: 3
    },
]


export const sidebar = [
    {
        name: 'Ferari',
        styl: 'linear-gradient(229.99deg, #e91f11 -26%, #9e8714 145%)',
        id: 1

    },
    {
        name: 'Toyota',
        styl: 'linear-gradient(221.87deg, #ea3d08 1%, #5305af 128%)',
        id: 2

    },
    {
        name: 'Aston Martin',
        styl: 'linear-gradient(220.16deg, #61615b -8%, #ad753a 138%)',
        id: 3
    }
]